<!-- 🔥 CALLS CONTAINER GLOBAL - Disponible en todas las páginas -->
<div class="calls-container" [class.disabled]="connectionStatus !== 'connected'">
  <app-call-card *ngFor="let call of calls; trackBy: trackByCallId" [type]="getCallType(call)"
    [callerName]="call.callerName || call.callerId" [callerId]="call.callerId" [callId]="call.id"
    [userData]="getUserDataForCall(call)" (answer)="answer(call.id)" (hangup)="hangup(call.id)" (hold)="hold(call.id)"
    (resume)="resume(call.id)">
  </app-call-card>
</div>

<!-- 🔥 ELEMENTO DE AUDIO GLOBAL (solo uno en toda la app) -->
<audio id="remoteAudio" hidden></audio>